import { MapPin, ArrowUpRight } from "lucide-react";

const MISSISSAUGA_HOODS = [
  "Port Credit", "Streetsville", "Erin Mills", "Meadowvale", "Cooksville",
  "Lorne Park", "Clarkson", "Square One", "City Centre", "Hurontario",
  "Heartland", "Churchill Meadows", "Erindale", "Lakeview", "Applewood",
];

const VAUGHAN_HOODS = [
  "Woodbridge", "Maple", "Concord", "Kleinburg", "Thornhill",
  "Patterson", "Vellore Village", "Carrville", "Pine Valley",
];

const GTA_CITIES = [
  "Toronto", "Etobicoke", "North York", "Scarborough", "Oakville",
  "Brampton", "Burlington", "Markham", "Richmond Hill",
];

export default function ServiceAreas() {
  return (
    <section
      id="service-areas"
      data-testid="service-areas-section"
      className="relative py-24 md:py-28 border-y border-white/5 bg-[#0c0119]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-4 font-label">
           Service Areas
          </div>
          <h2 className="font-display text-4xl md:text-5xl leading-[1]">
            Mississauga's <span className="text-jester">#1 ceramic coating</span><br />
            studio. serving the entire GTA.
          </h2>
          <p className="mt-5 text-white/65 max-w-2xl mx-auto leading-relaxed">
            Two studios. One team. Free pickup &amp; delivery on packages over $800
            anywhere in the GTA.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-5">
          {/* Mississauga card. primary */}
          <a
            href="/ceramic-coating-mississauga"
            data-testid="service-area-mississauga"
            className="group relative overflow-hidden rounded-2xl border border-acid/30 bg-gradient-to-br from-jester-purple/15 to-[#120127] p-7 hover:border-acid transition-all"
          >
            <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-acid/10 blur-3xl group-hover:bg-acid/20 transition-colors" />
            <div className="relative">
              <div className="flex items-start justify-between mb-5">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-xl bg-acid/15 border border-acid/30 flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-acid" />
                  </div>
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-acid font-label">
                      Primary · #1 Rated
                    </div>
                    <div className="font-display text-xl mt-0.5">
                      Ceramic Coating <span className="text-jester">Mississauga</span>
                    </div>
                  </div>
                </div>
                <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-acid transition-colors" />
              </div>
              <p className="text-white/70 leading-relaxed text-sm mb-5">
                Mississauga's most-reviewed ceramic coating studio. Hand-finished
                2-layer 9H ceramic. from $550. 250+ five-star reviews.
              </p>
              <div className="flex flex-wrap gap-1.5">
                {MISSISSAUGA_HOODS.slice(0, 12).map((h) => (
                  <span
                    key={h}
                    className="px-2.5 py-1 rounded-full bg-white/5 border border-white/10 text-[11px] text-white/70 group-hover:border-acid/30 transition-colors"
                  >
                    {h}
                  </span>
                ))}
              </div>
            </div>
          </a>

          {/* Vaughan card */}
          <a
            href="/ceramic-coating-vaughan"
            data-testid="service-area-vaughan"
            className="group relative overflow-hidden rounded-2xl border border-jester-purple/40 bg-gradient-to-br from-jester-purple/15 to-[#120127] p-7 hover:border-jester transition-all"
          >
            <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-jester-purple/15 blur-3xl group-hover:bg-jester-purple/25 transition-colors" />
            <div className="relative">
              <div className="flex items-start justify-between mb-5">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-xl bg-jester-purple/20 border border-jester-purple/40 flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-jester" />
                  </div>
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-jester font-label">
                      Vaughan Studio
                    </div>
                    <div className="font-display text-xl mt-0.5">
                      Ceramic Coating <span className="text-jester">Vaughan</span>
                    </div>
                  </div>
                </div>
                <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-jester transition-colors" />
              </div>
              <p className="text-white/70 leading-relaxed text-sm mb-5">
                Vaughan's most-trusted ceramic coating shop on Hwy 7. Free pickup
                &amp; delivery across Woodbridge, Maple, Kleinburg, Thornhill.
              </p>
              <div className="flex flex-wrap gap-1.5">
                {VAUGHAN_HOODS.map((h) => (
                  <span
                    key={h}
                    className="px-2.5 py-1 rounded-full bg-white/5 border border-white/10 text-[11px] text-white/70 group-hover:border-jester/30 transition-colors"
                  >
                    {h}
                  </span>
                ))}
              </div>
            </div>
          </a>

          {/* GTA-wide card */}
          <div
            data-testid="service-area-gta"
            className="relative overflow-hidden rounded-2xl border border-white/10 bg-jester-card p-7"
          >
            <div className="flex items-start gap-3 mb-5">
              <div className="w-11 h-11 rounded-xl bg-jester-purple/20 border border-white/10 flex items-center justify-center">
                <MapPin className="w-5 h-5 text-acid" />
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 font-label">
                  Also Serving
                </div>
                <div className="font-display text-xl mt-0.5">
                  Across the <span className="text-jester">GTA</span>
                </div>
              </div>
            </div>
            <p className="text-white/70 leading-relaxed text-sm mb-5">
              Free pickup &amp; delivery within 25 km on coating packages over $800.
              Drivers from across the Greater Toronto Area choose Jester Werks.
            </p>
            <div className="flex flex-wrap gap-1.5 mb-5">
              {GTA_CITIES.map((c) => (
                <span
                  key={c}
                  className="px-2.5 py-1 rounded-full bg-white/5 border border-white/10 text-[11px] text-white/70"
                >
                  {c}
                </span>
              ))}
            </div>
            <div className="flex flex-wrap gap-3">
              <a
                href="/ceramic-coating-toronto"
                data-testid="link-ceramic-toronto"
                className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-acid font-label hover:text-white transition-colors"
              >
                Toronto Page <ArrowUpRight className="w-3 h-3" />
              </a>
              <a
                href="/paint-correction-mississauga"
                data-testid="link-paint-correction"
                className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-acid font-label hover:text-white transition-colors"
              >
                Paint Correction <ArrowUpRight className="w-3 h-3" />
              </a>
              <a
                href="/blog"
                data-testid="link-blog"
                className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-acid font-label hover:text-white transition-colors"
              >
                Blog <ArrowUpRight className="w-3 h-3" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
